<template>
  <div class="realtive h-full w-full">
    <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" />
    <div class="mt-20px tab-wrap">
      <!-- 基本信息start -->
      <div v-show="activeTab === '基本信息'">
        <el-form
          :model="baseInfoFormData"
          ref="formRef"
          label-width="100px"
          disabled
          label-suffix=" :"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案编号')}`">
                <el-input size="small" v-model="baseInfoFormData.no" class="w-full"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案名称')}`">
                <el-input size="small" v-model="baseInfoFormData.name" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案类型')}`">
                <el-input size="small" v-model="baseInfoFormData.typeName" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('所属部门')}`">
                <el-input
                  size="small"
                  v-model="baseInfoFormData.eascOrganizationName"
                  class="w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('版次')}`">
                <el-input class="mr-10px" size="small" v-model="baseInfoFormData.version" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('编制概要')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="baseInfoFormData.summary"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <categoryTitle title="版次及记录" />
        <el-table :data="versionTableList" class="mt-20px" height="200px" ref="tableRef">
          <el-table-column :label="`${$t('序号')}`" type="index" width="50"></el-table-column>
          <el-table-column
            :label="`${$t('版次')}`"
            prop="version"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('编制与修订概要')}`"
            prop="summary"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订人')}`"
            prop="writeName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订时间')}`"
            prop="creationTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column :label="`${$t('状态')}`" show-overflow-tooltip>
            <template #default="{ row: { status } }">
              {{ status ? statusList[status - 1].label : '' }}
            </template>
          </el-table-column>
          <el-table-column
            :label="`${$t('发布人')}`"
            prop="publisher"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('发布时间')}`" prop="publishDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('实施时间')}`" prop="executeDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('操作')}`" width="50">
            <template #default="{ row }">
              <p @click="viewLastVersion(row)" class="cursor-pointer text-[#44F1FF]">{{ $t('查看') }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 基本信息end -->

      <!-- 总则start -->
      <div v-show="activeTab === '总则'">
        <el-form :model="generalRulesFormData" label-width="110px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('编制目的')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="generalRulesFormData.purpose"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('编制依据')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="generalRulesFormData.accord"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('适用范围')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="generalRulesFormData.range"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案体系')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="generalRulesFormData.system"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急工作原则')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="generalRulesFormData.policy"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 总则end -->

      <!-- 风险与资源分析start -->
      <div v-show="activeTab === '风险与资源分析'">
        <el-form :model="riskAndResourceFormData" label-width="110px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('公司概况')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="riskAndResourceFormData.companyOverview"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('风险辨识分析')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="riskAndResourceFormData.risk"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急资源')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="riskAndResourceFormData.resource"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 风险与资源分析end -->

      <!-- 应急组织机构及职责start -->
      <div v-show="activeTab === '应急组织机构及职责'">
        <div class="w-full overflow-hidden">
          <el-button
            size="mini"
            type="primary"
            :disabled="!$hasAccess('chart')"
            class="float-right"
            @click="showTreeChart"
            >应急组织架构图</el-button
          >
        </div>
        <el-table
          :data="dutyMemberTableList"
          v-loading="dutyMemberTableLoading"
          :highlight-current-row="true"
          class="mt-10px"
          height="calc(100% - 60px)"
          ref="dutyTableRef"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('人员名称')}`"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('应急组织名称')}`"
            prop="organizationName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('组织角色')}`"
            prop="roleName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('部门')}`"
            prop="eascOrganizationName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('岗位')}`" prop="eascPostName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            :label="`${$t('联系方式')}`"
            prop="userMobilePhoneNo"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="mt-20px text-center"
          background
          small
          @size-change="dutyMemberSizeChange"
          @current-change="dutyMemberSearchList"
          :current-page.sync="dutyMemberPage.pageNo"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :page-size.sync="dutyMemberPage.pageSize"
          layout="total, prev, pager, next"
          :total="dutyMemberPage.pageTotal"
        ></el-pagination>
      </div>
      <!-- 应急组织机构及职责end -->

      <!-- 预警及信息报告start -->
      <div v-show="activeTab === '预警及信息报告'">
        <el-form :model="reportFormData" label-width="100px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('预警')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="reportFormData.warning"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('信息报告')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="reportFormData.report"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 预警及信息报告end -->

      <!-- 应急响应start -->
      <div v-show="activeTab === '应急响应'">
        <el-form :model="responseFormData" label-width="150px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急处置和现场救援')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="responseFormData.disposeRescue"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急响应调整')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="responseFormData.adjust"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急结束')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="responseFormData.end"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <categoryTitle title="响应等级" />
        <el-table
          :data="responseTableList"
          v-loading="responseTableLoading"
          :highlight-current-row="true"
          height="200px"
          class="mt-10px"
          ref="tableRef"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('响应等级')}`"
            prop="gradeName"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('启动条件')}`"
            prop="startingConditions"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('响应程序')}`"
            prop="responseProcedure"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <!-- 应急响应end -->

      <!-- 信息公开start -->
      <div v-show="activeTab === '信息公开'">
        <el-form :model="disclosureFormData" label-width="150px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('信息公开的责任部门')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="disclosureFormData.department"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('信息公开的责任人')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="disclosureFormData.person"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('信息发布程序')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="disclosureFormData.publisher"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('信息公开的原则')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="disclosureFormData.policy"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('媒体沟通')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="disclosureFormData.media"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 信息公开end -->

      <!-- 后期处置start -->
      <div v-show="activeTab === '后期处置'">
        <el-form :model="lateDisposalFormData" label-width="150px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('污染物处置及生产秩序的恢复')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="lateDisposalFormData.restore"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('医疗救治')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="lateDisposalFormData.treatment"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('人员的安置')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="lateDisposalFormData.resettle"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('善后及赔偿')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="lateDisposalFormData.compensate"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急救援评估')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="lateDisposalFormData.estimate"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 后期处置end -->

      <!-- 应急保障start -->
      <div v-show="activeTab === '应急保障'">
        <el-form :model="securityFormData" label-width="150px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('通信与信息保障')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="securityFormData.message"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急队伍保障')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="securityFormData.ranks"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('物资装备保障')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="securityFormData.goods"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('经费保障')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="securityFormData.money"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 应急保障end -->

      <!-- 应急预案管理start -->
      <div v-show="activeTab === '应急预案管理'">
        <el-form :model="planManagementFormData" label-width="150px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案培训')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="planManagementFormData.train"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案演练')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="planManagementFormData.drill"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案修订')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="planManagementFormData.amend"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案备案')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="planManagementFormData.filings"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急预案实施')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="planManagementFormData.execute"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 应急预案管理end -->

      <!-- 附件start -->
      <div v-show="activeTab === '附件'">
        <el-row>
          <FileInfo :fileIdList="fileIdList" />
        </el-row>
      </div>
      <!-- 附件end -->
    </div>
    <!-- 应急组织架构图start -->
    <el-dialog
      v-dialogDrag
      append-to-body
      class="small-dialog"
      :title="`${$t('应急组织架构图')}`"
      :visible.sync="treeChartVis"
      :close-on-click-modal="false"
    >
      <TreeChart :json="tree" v-for="(tree, index) in treeData" :key="index"></TreeChart>
    </el-dialog>
    <!-- 应急组织架构图end -->
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import dayjs from 'dayjs'
import { PlanApi } from '@wiz-api/emergency-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const planApi = new PlanApi()
const TreeChart = () => {
  return import('./TreeChart')
}
const FileInfo = () => {
  return import('./FileInfo')
}
export default {
  name: 'ComprehensivePlan',
  components: {
    categoryTitle,
    tableButtonGroup,
    TreeChart,
    FileInfo,
  },
  props: {
    planRowId: {
      type: String,
      default: '',
    },
    statusList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    planRowId: {
      handler(newVal, oldVal) {
        newVal && this.getPlanDetail(newVal)
      },
      immediate: true,
    },
  },
  data() {
    return {
      tabList: [
        '基本信息',
        '总则',
        '风险与资源分析',
        '应急组织机构及职责',
        '预警及信息报告',
        '应急响应',
        '信息公开',
        '后期处置',
        '应急保障',
        '应急预案管理',
        '附件',
      ],
      activeTab: '基本信息',
      currentDataIndex: 0,
      wfiles: '',
      categoryList: [],
      dialogTitle: '', // 标题
      baseInfoFormData: {
        no: '', // 预案编号
        name: '', // 预案名称
        categoryId: '', // 预案类别
        categoryName: '',
        typeName: '', // 预案类型
        eascOrganizationID: '', // 所属部门
        version: '', // 版次
        summary: '', // 编制概要
      }, // 基本信息表单数据
      generalRulesFormData: {
        purpose: '', // 编制目的
        accord: '', // 编制依据
        range: '', // 适用范围
        system: '', // 应急预案体系
        policy: '', // 应急工作原则
      }, // 总则表单数据
      riskAndResourceFormData: {
        companyOverview: '', // 公司概况
        risk: '', // 风险辨识分析
        resource: '', // 应急资源
      }, // 风险与资源分析表单数据
      reportFormData: {
        warning: '', // 预警
        report: '', // 信息报告
      }, // 预警及信息报告表单数据
      responseFormData: {
        disposeRescue: '', // 应急处置和现场救援
        adjust: '', // 应急响应调整
        end: '', // 应急结束
      }, // 应急响应表单数据
      disclosureFormData: {
        department: '', // 信息公开的责任部门
        person: '', // 信息公开的责任人
        publisher: '', // 信息发布程序
        policy: '', // 信息公开的原则
        media: '', // 媒体沟通
      }, // 信息公开表单数据
      lateDisposalFormData: {
        restore: '', // 污染物处置及生产秩序的恢复
        treatment: '', // 医疗救治
        resettle: '', // 人员的安置
        compensate: '', // 善后及赔偿
        estimate: '', // 应急救援评估
      }, // 后期处置表单数据
      securityFormData: {
        message: '', // 通信与信息保障
        ranks: '', // 应急队伍保障
        goods: '', // 物资装备保障
        money: '', // 经费保障
      }, // 应急保障表单数据
      planManagementFormData: {
        train: '', // 应急预案培训
        drill: '', // 应急预案演练
        amend: '', // 应急预案修订
        filings: '', // 应急预案备案
        execute: '', // 应急预案实施
      }, // 应急预案管理表单数据
      saveLoading: false, // 保存按钮loading
      operateType: 'create', // 操作类型 read update create
      typeNameList: [], // 预案类型下拉框数据
      dutyMemberTableList: [], // 应急组织机构及职责列表数据
      allDutyMemberTableList: [], // 所有的应急组织机构及职责列表数据
      dutyMemberTableLoading: false, // 应急组织机构及职责列表loading
      responseTableList: [], // 应急响应列表数据
      responseTableLoading: false, // 应急响应列表loading
      dutyMemberPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      }, // 应急组织机构及职责列表分页器
      showResponseLevelDetailDialog: false, // 是否显示应急响应新增弹窗页面
      responseLevelOperateType: '', // 应急响应操作类型
      responseLevelOperateData: '', // 应急响应操作项数据
      showApprovalPlanDialog: false, // 是否显示审批弹窗
      showRevisePlanDialog: false, // 是否显示提交修订弹窗
      showIssuePlanDialog: false, // 是否显示发布弹窗
      departmentList: [], // 所属部门下拉框数据
      showPersonDialog: false, // 是否显示添加成员弹窗
      isRevise: false, // 是否发起了修订请求
      levelList: [], // 剩余响应等级下拉框数据
      versionTableList: [], // 版次及记录列表数据
      selectedPersonList: [], // 已选择的人员
      fileList: [], // 上传附件的列表
      fileIdList: [], // 上传成功文件的文件id
      fileMap: {}, // 上传成功文件名与文件id的映射
      approvalData: {}, // 审批需要的参数
      treeData: [], // 组织架构图数据
      treeChartVis: false, // 组织架构图的显隐
    }
  },
  methods: {
    // 从数据字典获取
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['PlanCategory', 'ResponseGrade'],
        includeDetails: true,
      })
      if (err) return
      const categoryList = res.find((item) => {
        return item.code === 'PlanCategory'
      })
      this.categoryList = categoryList?.dataItems || []
      const responseLevelList = res.find((item) => {
        return item.code === 'ResponseGrade'
      })
      this.responseLevelList = responseLevelList?.dataItems || []
    },
    /**
     * @description 添加成员
     */
    addMember() {
      this.showPersonDialog = true
    },

    /**
     * @description 获取人员列表
     * @param {Array} persons 已选择人员列表
     */
    async getPersonList(persons) {
      // if (!persons.length) return

      // 排除已存在的成员
      const joinPersonList = [...persons]
      // _.forEach(persons, (person) => {
      //   const findItem = _.find(this.allDutyMemberTableList, (memberItem) => {
      //     return memberItem.id === person.id
      //   })
      //   if (!findItem) {
      //     joinPersonList.push(person)
      //   }
      // })
      // if (!joinPersonList.length) return
      this.dutyMemberTableList = []
      this.allDutyMemberTableList = []

      this.dutyMemberTableLoading = true
      const [err, res] = await employeeApi.getEmployeeList({
        userIds: _.map(joinPersonList, 'id'),
      }) // 获取指定用户信息
      this.dutyMemberTableLoading = false
      if (!err) {
        const personList = [...joinPersonList]
        const memberList = []
        if (res.length) {
          _.forEach(personList, (personItem) => {
            _.forEach(res, (userItem) => {
              if (userItem.userID === personItem.id) {
                // 删除已匹配项
                const macthIndex = _.findIndex(joinPersonList, (joinPersonItem) => {
                  return personItem.id === joinPersonItem.id
                })
                if (macthIndex !== -1) {
                  joinPersonList.splice(macthIndex, 1)
                }

                if (personItem.roleName && personItem.roleID) {
                  const item = {
                    ...personItem,
                    roleName: userItem.roleName,
                    roleID: userItem.roleID,
                    organizationName: userItem.organizationName,
                    organizationID: userItem.organizationID,
                    eascOrganizationID: personItem.organizationUnitIdList
                      ? personItem.organizationUnitIdList.join(',')
                      : userItem.eascOrganizationID,
                    eascOrganizationName: personItem.organizationUnitNameList
                      ? personItem.organizationUnitNameList.join(',')
                      : userItem.eascOrganizationName,
                    eascPostID: personItem.posts
                      ? _.map(personItem.posts, 'postId').join(',')
                      : userItem.eascPostID,
                    eascPostName: personItem.posts
                      ? _.map(personItem.posts, 'postName').join(',')
                      : userItem.eascPostName,
                    userMobilePhoneNo: personItem.phoneNumber
                      ? personItem.phoneNumber
                      : userItem.userMobilePhoneNo,
                    userId: personItem.id,
                  }
                  if (this.$route.query.planRowId) {
                    item.planID = this.$route.query.planRowId
                  }
                  memberList.push(item)
                } else {
                  personItem.roleName = userItem.roleName
                  personItem.roleID = userItem.roleID
                  personItem.organizationName = userItem.organizationName
                  personItem.organizationID = userItem.organizationID
                  personItem.eascOrganizationID = personItem.organizationUnitIdList
                    ? personItem.organizationUnitIdList.join(',')
                    : userItem.eascOrganizationID
                  personItem.eascOrganizationName = personItem.organizationUnitNameList
                    ? personItem.organizationUnitNameList.join(',')
                    : userItem.eascOrganizationName
                  personItem.eascPostID = personItem.posts
                    ? _.map(personItem.posts, 'postId').join(',')
                    : userItem.eascPostID
                  personItem.eascPostName = personItem.posts
                    ? _.map(personItem.posts, 'postName').join(',')
                    : userItem.eascPostName
                  personItem.userMobilePhoneNo = personItem.phoneNumber
                    ? personItem.phoneNumber
                    : userItem.userMobilePhoneNo
                  personItem.userId = personItem.id
                  if (this.$route.query.planRowId) {
                    personItem.planID = this.$route.query.planRowId
                  }
                  memberList.push(personItem)
                }
              }
            })
          })
        }

        _.forEach(joinPersonList, (personItem) => {
          personItem.roleName = ''
          personItem.roleID = null
          personItem.organizationName = ''
          personItem.organizationID = null
          if (!personItem.eascOrganizationID) {
            personItem.eascOrganizationID = personItem.organizationUnitIdList
              ? personItem.organizationUnitIdList.join(',')
              : ''
            personItem.eascOrganizationName = personItem.organizationUnitNameList
              ? personItem.organizationUnitNameList.join(',')
              : ''
          }
          if (!personItem.eascPostID) {
            personItem.eascPostID = personItem.posts
              ? _.map(personItem.posts, 'postId').join(',')
              : ''
            personItem.eascPostName = personItem.posts
              ? _.map(personItem.posts, 'postName').join(',')
              : ''
          }
          personItem.userMobilePhoneNo = personItem.userMobilePhoneNo
            ? personItem.userMobilePhoneNo
            : personItem.phoneNumber
          personItem.userId = personItem.id
          if (this.$route.query.planRowId) {
            personItem.planID = this.$route.query.planRowId
          }
          memberList.push(personItem)
        })

        this.allDutyMemberTableList.push(...memberList)
        this.dutyMemberTableList = this.allDutyMemberTableList.slice(
          (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
          this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
        )
        this.$nextTick(() => {
          if (this.$refs.dutyTableRef) {
            this.$refs.dutyTableRef.doLayout()
          }
        })
        this.dutyMemberPage.pageTotal = this.allDutyMemberTableList.length
      }
    },

    /**
     * @description 应急组织机构及职责删除成员
     * @param {Number} deleteIndex 删除项位置
     */
    deleteDutyMember(deleteIndex) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(() => {
        const deleteMember = this.dutyMemberTableList.splice(deleteIndex, 1)
        const deleteInIndex = _.findIndex(this.allDutyMemberTableList, (dutyItem) => {
          return dutyItem.userId === deleteMember[0].userId
        })
        if (deleteInIndex !== -1) {
          this.allDutyMemberTableList.splice(deleteInIndex, 1)
          // this.dutyMemberPage.pageTotal = this.allDutyMemberTableList.length
          this.$nextTick(() => {
            console.log('this.allDutyMemberTableList.length', this.allDutyMemberTableList.length)
            this.$set(this.dutyMemberPage, 'pageTotal', this.allDutyMemberTableList.length)
            this.dutyMemberTableList = this.allDutyMemberTableList.slice(
              (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
              this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
            )
            if (this.dutyMemberTableList.length === 0 && this.dutyMemberPage.pageNo > 1) {
              this.dutyMemberPage.pageNo -= 1
              this.dutyMemberTableList = this.allDutyMemberTableList.slice(
                (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
                this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
              )
            }
            this.$nextTick(() => {
              if (this.$refs.dutyTableRef) {
                this.$refs.dutyTableRef.doLayout()
              }
            })
          })
        }
      })
    },

    /**
     * @description 部门列表查询
     */
    async getDepartmentList() {
      this.departmentLoading = true
      const [err, res] = await organizationApi.getList({
        sorting: '', // 排序
        skipCount: 0,
        maxResultCount: 999,
      })
      this.departmentLoading = false
      if (!err) {
        this.departmentList = res.items
      }
    },

    /**
     * @description 应急组织机构及职责列表查询
     */
    dutyMemberSearchList() {
      this.dutyMemberTableList = this.allDutyMemberTableList.slice(
        (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
        this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
      )
    },

    /**
     * @description 应急组织机构及职责分页数改变
     */
    dutyMemberSizeChange() {
      this.dutyMemberPage.pageNo = 1
      this.dutyMemberSearchList()
    },

    /**
     * @description 返回主页列表
     */
    goRegulationList() {
      this.$router.push('/contingency-plan/management-list')
    },

    /**
     * @description 应急响应等级查看、编辑、新增
     * @param {Object} responseRow 操作项数据
     * @param {String} type 操作类型
     */
    responseLevelToDetail(responseRow, type, index) {
      this.currentDataIndex = index || 0
      let responseTableLevel = _.map(this.responseTableList, 'gradeId') // 列表中已用到等级
      if (type !== 'create') {
        responseTableLevel = responseTableLevel.filter((item) => {
          return responseRow.gradeId !== item
        })
      }
      this.levelList = _.filter(this.responseLevelList, (levelItem) => {
        return !responseTableLevel.includes(levelItem.id)
      })
      this.responseLevelOperateType = type
      this.responseLevelOperateData = responseRow
      this.showResponseLevelDetailDialog = true
    },

    /**
     * @description 应急响应等级添加
     * @param {Object} levelData 添加项数据
     */
    addLevel(levelData) {
      if (this.responseLevelOperateType === 'create') {
        this.responseTableList.push(levelData)
      } else if (this.responseLevelOperateType === 'update') {
        this.responseTableList.splice(this.currentDataIndex, 1, levelData)
      }
    },

    /**
     * @description 应急响应等级删除
     * @param {Number} deleteIndex 删除项数据位置
     */
    deleteResponseLevel(deleteIndex) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(() => {
        this.responseTableList.splice(deleteIndex, 1)
      })
    },

    /**
     *@description 审核
     */
    approvalPlan() {
      this.showApprovalPlanDialog = true
    },

    /**
     *@description 修订
     */
    revisePlan() {
      this.showRevisePlanDialog = true
    },

    /**
     *@description 发布
     */
    issuePlan() {
      this.showIssuePlanDialog = true
    },

    /**
     * @description 获取预案信息
     * @param {String} planId 预案id
     */
    async getPlanDetail(planId) {
      const [err, res] = await planApi.getPlan({
        id: planId,
      })
      if (!err) {
        this.fileIdList = _.map(res.planFiles, 'fileUrl')
        this.baseInfoFormData = res.plan
        this.securityFormData = res.planIndemnity
        this.disclosureFormData = res.planInformation
        this.lateDisposalFormData = res.planLaterDispose
        this.planManagementFormData = res.planManagement
        this.responseFormData = res.planResponse
        this.riskAndResourceFormData = res.planRiskResource
        this.generalRulesFormData = res.planRule
        this.reportFormData = res.planWarning
        this.responseTableList = res.planResponseGrades
        this.versionTableList = res.planVersions.filter((item) => {
          return [4, 5].includes(item.status)
        })
        this.allDutyMemberTableList = res.planOrgs
        // 将数据设置成可以在人员选择中使用反选的数据
        _.forEach(this.allDutyMemberTableList, (memberItem) => {
          memberItem.id = memberItem.userId
          memberItem.keyIds = _.map(
            memberItem.eascOrganizationID.split(','),
            (organizationUnitId) => {
              return organizationUnitId + memberItem.userId
            }
          )
        })
        this.dutyMemberTableList = this.allDutyMemberTableList.slice(
          (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
          this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
        )
        this.dutyMemberPage.pageTotal = this.allDutyMemberTableList.length
        _.forEach(this.versionTableList, (versionItem) => {
          if (versionItem.publishDate) {
            versionItem.publishDate = dayjs(new Date(versionItem.publishDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.executeDate) {
            versionItem.executeDate = dayjs(new Date(versionItem.executeDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.creationTime) {
            versionItem.creationTime = dayjs(new Date(versionItem.creationTime)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
      }
    },

    /**
     * @description 获取上传文件
     */
    async getFile(id) {
      const [err, res] = await fileApi.getFileContent(id)
      if (!err) {
        return res
      }
      return null
    },

    /**
     * @description 查看该版次预案数据
     * @param {String} planId 预案id
     */
    viewLastVersion(row) {
      if (row.version === this.baseInfoFormData.version) return
      this.getPlanDetail(row.id)
    },

    /**
     * @description 查看该条数据的应急组织架构图
     * @param {String} planId 预案id
     */
    async showTreeChart() {
      this.treeChartVis = true // visble
      const [err, res] = await planApi.getOrgStructure({
        id: this.planRowId,
      })
      if (!err) {
        this.treeData = res.items
      }
    },
  },
  created() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
.tab-wrap {
  height: calc(100% - 48px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  > div {
    height: calc(100% - 56px);
  }
}
</style>
